export const booleanOptions = [
  { value: "1", label: "SI" },
  { value: "0", label: "NO" },
];
